export const SET_CASH_FLOW = 'setCashFlow'
export const SET_CASH_FLOWS = 'setCashFlows'
export const SET_CASH_FLOWS_SIMPLE = 'setCashFlowsSimple'
export const SET_CATEGORIES = 'setCategories'
export const SET_CASH_FLOW_ACTIVE = 'setCashFlowActive'
export const CASH_FLOW_RESET = 'setReset'
export const CASH_FLOW_RESET_STATE = 'setCashFlowResetState'
export const SET_CASH_FLOW_PAGINATION = 'setCashFlowPagination'